<template>
  <div class="auth-page__intro">
    <div v-if="this.isUserGuest()">
      <a class="btn  btn--main  btn--lg  mb-0" href="javascript:void(0)"@click="authUrl('/adm/auth/url')">Войти в личный
        кабинет</a>
    </div>

    <div v-if="!this.isUserGuest()">
      <router-link class="btn  btn--main  btn--lg  mb-0" :to="{ name: 'inspections' }">Перейти в личный
        кабинет</router-link>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Home',
    data() {
      return {
        isLoading: false
      };
    },
    created: function () {
      if (this.$route.name === 'auth.callback' && this.authCode()) {
        this.isLoading = true;
        this.clearLocalStorage();

        axios.post(process.env.VUE_APP_ROOT_API + '/adm/auth/callback', {
          'code': this.authCode(),
          'state': 3
        }).then((response) => {

          if (response.data.success) {
            this.setLocalStorage({
              profile: response.data.data.profile,
              accessToken: response.data.data.accessToken,
              refreshToken: response.data.data.refreshToken
            });
          }

        }).finally(() => {
          this.isLoading = false;
          this.$router.push({ name: 'inspections' });
        });
      }
    },
    methods: {
      authCode() {
        return this.$route.query.code;
      }
    }
  }
</script>
